import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import NoAccountWarningContent from './NoAccountWarningContent';
const NoAccountWarning = ({ accountMenuController, noAccountWarningController }) => {
    //const canShow = noAccountWarningController.show
    const canShow = false;
    return canShow ? (_jsx(NoAccountWarningContent, { accountMenuController: accountMenuController, noAccountWarningController: noAccountWarningController })) : null;
};
export default observer(NoAccountWarning);
